<template>
  <v-item v-slot="{ isSelected, toggle }" :value="value">
    <v-card
      ref="card"
      :ripple="false"
      :color="isSelected ? type : undefined"
      :max-width="maxWidth"
      class="so-radio-card-chart w-100 flex-1-1-0 rounded"
      :class="{
        'so-radio-card-chart--selected': isSelected,
      }"
      tabindex="0"
      data-testid="so-radio-card-chart"
      @click="toggle"
      @keyup.enter="toggle"
    >
      <div class="d-flex pa-5 align-center">
        <div>
          <v-progress-circular
            :size="70"
            :width="12"
            :color="isSelected ? 'white' : type"
            :model-value="percentage"
          />
        </div>
        <div class="ml-5">
          <div class="text-h6 mb-1">{{ title }}</div>
          <SoSkeleton v-if="isLoading" width="8em" height="2em" />
          <slot v-else>
            <div class="text-h2">{{ text }}</div>
          </slot>
        </div>
      </div>
    </v-card>
  </v-item>
</template>

<script lang="ts">
  import { SoRadioCardChartType } from "@/types/components/SoRadioCardChart"
  import { defineComponent, PropType } from "vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"

  export default defineComponent({
    components: {
      SoSkeleton,
    },
    inheritAttrs: false,
    props: {
      modelValue: {
        type: [Number, String],
        default: null,
      },
      value: {
        type: [Number, String],
        default: undefined,
      },
      type: {
        type: String as PropType<SoRadioCardChartType>,
        default: "default",
      },
      maxWidth: {
        type: String,
        default: null,
      },
      title: {
        type: String,
        default: null,
      },
      text: {
        type: String,
        default: null,
      },
      percentage: {
        type: Number,
        default: 0,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
  })
</script>

<style scoped>
  .so-radio-card-chart {
    border: 1px solid rgb(var(--v-theme-border));
    border-radius: var(--theme-radius);
    box-shadow: none;
  }
  .so-radio-card-chart--selected {
    box-shadow:
      0px 3px 6px -1px rgba(0, 0, 0, 0.04),
      0px 4px 16px 0px rgba(0, 0, 0, 0.1);
    border-color: transparent;
  }
  .so-radio-card-chart:focus-visible {
    outline: var(--theme-outline);
  }
</style>
